import {
  uoUMultiCurrencySuggestionBannerClickSrc64Evid331,
  uoUMultiCurrencySuggestionBannerShownSrc64Evid330,
  uoUUrrencyConverterLoadedSrc64Evid332,
  uoUMultiCurrencySuggestedCurrencyAutoAppliedSrc64Evid333,
} from '@wix/bi-logger-payments-data/v2';
import {APP_DEFINITION_ID} from '../../constants';
import {BiParams} from '../../../types/common';

export const useBIEvents = () => {
  const sendBIEventOnPopoverShow = ({
    biParams,
    selectedCurrency,
    suggestedCurrencyCode,
  }: {
    biParams: BiParams;
    selectedCurrency: string;
    suggestedCurrencyCode: string;
  }) =>
    uoUMultiCurrencySuggestionBannerShownSrc64Evid330({
      visitorId: biParams.visitorId,
      appid: APP_DEFINITION_ID,
      origin: biParams.currentPageId,
      pagename: biParams.currentPageName,
      sessionId: localStorage.getItem('fedops.logger.sessionId'),
      memberId: biParams.ownerId,
      msid: biParams.msid,
      changeFromCurrency: selectedCurrency,
      changeToCurrency: suggestedCurrencyCode,
    });

  const sendBIEventOnPopoverClick = ({
    biParams,
    selectedCurrency,
    suggestedCurrencyCode,
    cta,
  }: {
    biParams: BiParams;
    selectedCurrency: string;
    suggestedCurrencyCode: string;
    cta: 'switch_to' | 'keep';
  }) =>
    uoUMultiCurrencySuggestionBannerClickSrc64Evid331({
      visitorId: biParams.visitorId,
      appid: APP_DEFINITION_ID,
      origin: biParams.currentPageId,
      pagename: biParams.currentPageName,
      sessionId: localStorage.getItem('fedops.logger.sessionId'),
      memberId: biParams.ownerId,
      msid: biParams.msid,
      changeFromCurrency: selectedCurrency,
      changeToCurrency: suggestedCurrencyCode,
      cta,
    });

  const sendBIEventWidgetLoaded = ({
    biParams,
    selectedCurrency,
    coords,
  }: {
    biParams: BiParams;
    selectedCurrency: string;
    coords: {coordinateX: number; coordinateY: number};
  }) =>
    uoUUrrencyConverterLoadedSrc64Evid332({
      visitorId: biParams.visitorId,
      appid: APP_DEFINITION_ID,
      origin: biParams.currentPageId,
      pagename: biParams.currentPageName,
      sessionId: localStorage.getItem('fedops.logger.sessionId'),
      memberId: biParams.ownerId,
      msid: biParams.msid,
      currency: selectedCurrency,
      coordinateX: coords.coordinateX,
      coordinateY: coords.coordinateY,
    });

  const sendBIEventOnSuggestedCurrencyAutoApplied = ({
    biParams,
    selectedCurrency,
    suggestedCurrencyCode,
  }: {
    biParams: BiParams;
    selectedCurrency: string;
    suggestedCurrencyCode: string;
  }) =>
    uoUMultiCurrencySuggestedCurrencyAutoAppliedSrc64Evid333({
      visitorId: biParams.visitorId,
      appid: APP_DEFINITION_ID,
      origin: biParams.currentPageId,
      pagename: biParams.currentPageName,
      sessionId: localStorage.getItem('fedops.logger.sessionId'),
      memberId: biParams.ownerId,
      msid: biParams.msid,
      changeFromCurrency: selectedCurrency,
      changeToCurrency: suggestedCurrencyCode,
    });

  return {
    sendBIEventOnPopoverShow,
    sendBIEventOnPopoverClick,
    sendBIEventWidgetLoaded,
    sendBIEventOnSuggestedCurrencyAutoApplied,
  };
};
